import AnimaliIcon from '../../../shared/Icons/tagMenuIcons/AnimaliIcon';
import CardiologiaIcon from '../../../shared/Icons/tagMenuIcons/CardiologiaIcon';
import CosmeticiIcon from '../../../shared/Icons/tagMenuIcons/CosmeticiIcon';
import CovidIcon from '../../../shared/Icons/tagMenuIcons/CovidIcon';
import FaceIcon from '../../../shared/Icons/tagMenuIcons/FaceIcon';
import FarmaciBancoIcon from '../../../shared/Icons/tagMenuIcons/FarmaciBancoIcon';
import FarmaciIcon from '../../../shared/Icons/tagMenuIcons/FarmaciIcon';
import FeetIcon from '../../../shared/Icons/tagMenuIcons/FeetIcons';
import InfanziaIcon from '../../../shared/Icons/tagMenuIcons/InfanziaIcon';
import IntegratoriIcon from '../../../shared/Icons/tagMenuIcons/IntegratoriIcon';
import OcchiIcon from '../../../shared/Icons/tagMenuIcons/OcchiIcon';
import OsteoporosiIcon from '../../../shared/Icons/tagMenuIcons/OsteoporosiIcon';
import PesoFormaIcon from '../../../shared/Icons/tagMenuIcons/PesoFormaIcon';
import ProdottiIcon from '../../../shared/Icons/tagMenuIcons/ProdottiIcon';
import { ImageDispatcher } from '../../../shared/ImageDispatcher/ImageDispatcher';

const tagLabels = [
  {
    tagTitle: 'Infanzia',
    tagIcon: InfanziaIcon(),
  },
  {
    tagTitle: 'Prodotti per animali',
    tagIcon: AnimaliIcon(),
  },
  {
    tagTitle: 'Benessere degli occhi',
    tagIcon: OcchiIcon(),
  },
  {
    tagTitle: 'Cosmetici',
    tagIcon: CosmeticiIcon(),
  },
  {
    tagTitle: 'Prodotti',
    tagIcon: ProdottiIcon(),
  },
  {
    tagTitle: 'Farmaci',
    tagIcon: FarmaciIcon(),
  },
  {
    tagTitle: 'Pesoforma',
    tagIcon: PesoFormaIcon(),
  },
  {
    tagTitle: 'Igiene',
    tagIcon: CovidIcon(),
  },
  {
    tagTitle: 'Integratori',
    tagIcon: IntegratoriIcon(),
  },
  {
    tagTitle: 'Osteoporosi',
    tagIcon: OsteoporosiIcon(),
  },
  {
    tagTitle: 'Cardiologia',
    tagIcon: CardiologiaIcon(),
  },
  {
    tagTitle: 'Sanitaria',
    tagIcon: FarmaciBancoIcon(),
  },
];

export default tagLabels;

export const TagIcon = ({ type, icon, color }) => {
  switch (type) {
    case 'Infanzia':
      return <InfanziaIcon color={color} />;
    case 'Prodotti per animali':
      return <AnimaliIcon color={color} />;
    case 'Benessere degli occhi':
    case 'Occhi':
      return <OcchiIcon color={color} />;
    case 'Cosmetici':
      return <CosmeticiIcon color={color} />;
    case 'Prodotti':
      return <ProdottiIcon color={color} />;
    case 'Farmaci':
      return <FarmaciIcon color={color} />;
    case 'Pesoforma':
    case 'Corpo':
      return <PesoFormaIcon color={color} />;
    case 'Igiene':
      return <CovidIcon color={color} />;
    case 'Integratori':
      return <IntegratoriIcon color={color} />;
    case 'Osteoporosi':
      return <OsteoporosiIcon color={color} />;
    case 'Cardiologia':
      return <CardiologiaIcon color={color} />;
    case 'Sanitaria':
      return <FarmaciBancoIcon color={color} />;
    case 'Viso':
      return <FaceIcon color={color} />;
    case 'Piedi':
      return <FeetIcon color={color} />;
    default:
      return !!icon ? (
        <ImageDispatcher src={icon} alt="Icona relativa al tag" />
      ) : (
        <ProdottiIcon color={color} />
      );
  }
};
